var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.d_wdmr22 && _vm.d_wdmr22.id)?_c('user-sms',{attrs:{"p_wdmr22":_vm.d_wdmr22,"p_selectedChild":_vm.d_selectedChild}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }